import { Column, Entity } from "typeorm";
import { AbstractEntity } from "../../../../database/common-entities";

@Entity('needle_model')
export class NeedleModelEntity extends AbstractEntity {

    @Column('varchar', {
        name: 'needle_model',
        length: 50,
        nullable: false
    })
    needleModel: string;
}